import { CreateDocumentType, DisplayLog, Module, PndStatus, PP30FormStatus, WhtCertificateStatus } from "@/enums/enums";
import { i18n } from "@/i18n";

function SetCreateDocumentType(moduleType: Module, status: number) {
  let createType;
  switch (moduleType) {
    case Module.Pnd:
      if (status === PndStatus.Draft) {
        createType = CreateDocumentType.Draft;
      } else if (status === PndStatus.AwaitFiling) {
        createType = CreateDocumentType.Approved;
      } else if (status === PndStatus.AwaitApproval) {
        createType = CreateDocumentType.AwaitApproval;
      } else {
        createType = CreateDocumentType.Created;
      }
      break;
    case Module.PP30Form:
      if (status === PP30FormStatus.Draft) {
        createType = CreateDocumentType.Draft;
      } else if (status === PP30FormStatus.AwaitFiling) {
        createType = CreateDocumentType.Approved;
      } else if (status === PP30FormStatus.AwaitApproval) {
        createType = CreateDocumentType.AwaitApproval;
      } else {
        createType = CreateDocumentType.Created;
      }
      break;
    case Module.WhtCertificate:
      if (status === WhtCertificateStatus.Draft) {
        createType = CreateDocumentType.Draft;
      } else if (status === WhtCertificateStatus.AwaitFiling) {
        createType = CreateDocumentType.Approved;
      } else if (status === WhtCertificateStatus.AwaitApproval) {
        createType = CreateDocumentType.AwaitApproval;
      } else {
        createType = CreateDocumentType.Created;
      }
      break;
    default:
      createType = CreateDocumentType.Created;
      break;
  }
  return createType;
}

function SetCreateDocumentClass(moduleType: Module, status: number) {
  const createType = SetCreateDocumentType(moduleType, status);
  let text: any = "";
  let classText = "";

  switch (createType) {
    case CreateDocumentType.Created:
      text = i18n.t("Create_Document");
      classText = "status create";
      break;
    case CreateDocumentType.Approved:
      text = i18n.t("Approved_Document");
      classText = "status approve";
      break;
    case CreateDocumentType.Draft:
      text = i18n.t("Saved_Draft");
      classText = "status create";
      break;
    case CreateDocumentType.AwaitApproval:
      text = i18n.t("Send_approve");
      classText = "status create";
      break;
  }

  return { text: text, classText: classText };
}

export function GetActivityLogStatus(displayLogType: DisplayLog, moduleType: Module, status: number) {
  let text: any = "";
  let classText = "";
  let classIconText = "";

  switch (displayLogType) {
    case DisplayLog.Create:
      text = SetCreateDocumentClass(moduleType, status).text;
      classText = SetCreateDocumentClass(moduleType, status).classText;
      classIconText = "fas fa-check";
      break;
    case DisplayLog.QuickCreate:
      text = i18n.t("Quick_Create_Document");
      classText = "status add";
      classIconText = "fas fa-check";
      break;
    case DisplayLog.ReadDetail:
      text = i18n.t("Viewed");
      classText = "status open";
      classIconText = "fas fa-eye";
      break;
    case DisplayLog.Update:
      text = i18n.t("Edited_Document");
      classText = "status edit";
      classIconText = "fas fa-pen";
      break;
    case DisplayLog.Delete:
      text = i18n.t("Voided_Document");
      classText = "status void";
      classIconText = "fas fa-times";
      break;
    case DisplayLog.UpdateStatus:
      text = i18n.t("Edited_Document_Status");
      classText = "status edit";
      classIconText = "fas fa-pen";
      break;
    case DisplayLog.UpdateIsFiled:
      text = i18n.t("Filing_Tax_Form");
      classText = "status record";
      classIconText = "fas fa-file-alt";
      break;
    case DisplayLog.UpdateIsPaid:
      text = i18n.t("Tax_Payment");
      classText = "status record";
      classIconText = "fas fa-wallet";
      break;
    case DisplayLog.AddComment:
      text = i18n.t("Add_Comment");
      classText = "status add";
      classIconText = "fas fa-comment-dots";
      break;
    case DisplayLog.VoidComment:
      text = i18n.t("Deleted_Comment");
      classText = "status delete";
      classIconText = "fas fa-comment-dots";
      break;
    case DisplayLog.AddFileStorage:
      text = i18n.t("Uploaded_Files");
      classText = "status create";
      classIconText = "fas fa-file-upload";
      break;
    case DisplayLog.VoidFileStorage:
      text = i18n.t("Deleted_Files");
      classText = "status void";
      classIconText = "fas fa-file-upload";
      break;
    case DisplayLog.UpdateIsClosingEntry:
      text = i18n.t("Record_Closing_Tax");
      classText = "status record";
      classIconText = "fas fa-calculator";
      break;
    case DisplayLog.CreateExpenseByIsClosingEntry:
      text = i18n.t("Record_Payment");
      classText = "status record";
      classIconText = "fas fa-calculator";
      break;
    case DisplayLog.FetchData:
      text = i18n.t("Header_FetchData");
      classText = "status open";
      classIconText = "fas fa-sync-alt";
      break;
    case DisplayLog.VoidIsClosingEntryPndExpense:
      text = i18n.t("Void_Record_Payment");
      classText = "status void";
      classIconText = "fas fa-times";
      break;
    case DisplayLog.VoidIsClosingEntryPndJournal:
      text = i18n.t("Void_Record_Closing_Tax");
      classText = "status void";
      classIconText = "fas fa-times";
      break;
    case DisplayLog.VoidIsFiled:
      text = i18n.t("Cancel_Filed");
      classText = "status void";
      classIconText = "fas fa-times";
      break;
    case DisplayLog.VoidIsPaid:
      text = i18n.t("Cancel_Tax_Payment");
      classText = "status void";
      classIconText = "fas fa-times";
      break;
  }

  return { text: text, classText: classText, classIconText: classIconText };
}
